"use client";

import { motion } from "framer-motion";
import styles from "./ProcedureArrows.module.css";

export default function ProcedureArrows() {
  const arrows = [
    { className: styles.arrow12, rotation: 0, delay: 0 },
    { className: styles.arrow23, rotation: 90, delay: 0.5 },
    { className: styles.arrow34, rotation: 180, delay: 1 },
    { className: styles.arrow41, rotation: 270, delay: 1.5 },
  ];

  return (
    <>
      {arrows.map((arrow, index) => (
        <motion.div
          key={index}
          className={`${styles.procedureArrow} ${arrow.className}`}
          initial={{ opacity: 0.2, scale: 0.9 }}
          animate={{
            opacity: [0.2, 1, 0.2],
            scale: [0.9, 1.05, 0.9],
          }}
          transition={{
            duration: 2,
            delay: arrow.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <motion.img
            src="/assets/sdtc-image/quy-trinh/arrow.svg"
            alt="Arrow flow"
            className={styles.arrowIcon}
            style={{ transform: `rotate(${arrow.rotation}deg)` }}
            animate={{
              filter: [
                "drop-shadow(0 0 0 rgba(0,123,255,0.1))",
                "drop-shadow(0 0 8px rgba(0,123,255,0.5))",
                "drop-shadow(0 0 0 rgba(0,123,255,0.1))",
              ],
            }}
            transition={{
              duration: 2,
              delay: arrow.delay,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        </motion.div>
      ))}
    </>
  );
}
